import { Controller } from "@hotwired/stimulus";

// household-incomes (Stimulus controller) — cf. issue #308
//
// « Revenus nets du foyer » est saisi au mois (`monthly_incomes`). Le champ
// readonly « Salaires annuels nets du foyer » affiche 12 × ce montant et
// alimente `yearly_incomes` (base du calcul d'impôt). Le recalcul est fait en
// JS à chaque saisie ; l'event `input`/`change` propagé sur le champ annuel
// déclenche api-sync (recalcul d'impôt) et la persistance edit-profile.
export default class extends Controller {
  static targets = ["monthly", "yearly"];

  connect() {
    this.initialSync();
  }

  // Au chargement : on rend les deux champs cohérents sans perdre de donnée.
  // - Si un revenu mensuel est saisi, on en déduit l'annuel (12 ×).
  // - Sinon, si seul l'annuel historique existe, on initialise le mensuel
  //   (annuel / 12) sans écraser l'annuel (évite de remettre l'impôt à 0 pour
  //   un profil existant qui n'avait pas de `monthly_incomes`).
  initialSync() {
    if (!this.hasMonthlyTarget || !this.hasYearlyTarget) return;
    const monthly = this.parse(this.monthlyTarget.value);
    const yearly = this.parse(this.yearlyTarget.value);

    if (monthly > 0) {
      this.setField(this.yearlyTarget, Math.round(monthly * 12));
    } else if (yearly > 0) {
      this.setField(this.monthlyTarget, Math.round(yearly / 12));
    } else {
      this.setField(this.yearlyTarget, 0);
    }
  }

  // Action sur input du champ mensuel : l'annuel suit (12 ×) et propage.
  recompute() {
    if (!this.hasMonthlyTarget || !this.hasYearlyTarget) return;
    const monthly = this.parse(this.monthlyTarget.value);
    this.setField(this.yearlyTarget, Math.round(monthly * 12), { propagate: true });
  }

  setField(field, value, { propagate = false } = {}) {
    field.value = String(value);
    field.dataset.raw = String(value);
    field.dispatchEvent(new Event("number-format:normalize"));

    if (propagate) {
      field.dispatchEvent(new Event("input", { bubbles: true }));
      field.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  parse(value) {
    if (value == null) return 0;
    const s = String(value)
      .replace(/\s|\u00A0/g, "")
      .replace(/,/g, ".")
      .replace(/[^0-9+\-.]/g, "");
    const n = Number(s);
    return isNaN(n) ? 0 : n;
  }
}
